// import React from 'react'
import { Route, Routes } from 'react-router-dom'
// import ResourceOptions from '../pages/UnAuth/ResourceOptions'
// import ResourceListing from '../pages/UnAuth/ResourceListing'
import ResourceDetails from '../pages/shared/Desktop/ResourceDetails'
import ResourceDetailsMobile from '../pages/shared/Mobile/ResourceDetails'

import Profile from '../pages/Auth/Desktop/Profile'
import Wallet from '../pages/Auth/Desktop/Wallet'
import WalletMobile from '../pages/Auth/Mobile/Wallet'
import ProfileMobile from '../pages/Auth/Mobile/Profile'
// import ProfileMobile from '../pages/Auth/Mobile/Profile'
// import Wallet from '../pages/Auth/Wallet'
import Privacy from '../pages/shared/Privacy'
import Terms from '../pages/shared/Terms'
import Disclaimer from '../pages/shared/Disclaimer'
import Eula from '../pages/shared/Eula'
import FinishSignIn from '../pages/shared/FinishSignIn';
import SavedResourceListing from '../pages/Auth/Desktop/SavedResources'
import SavedResourceListingMobile from '../pages/Auth/Mobile/SavedResources'

import { SearchFilterOptionType } from "../data/types";
import Cart from '../pages/Auth/Cart'
import Feed from '../pages/Auth/Feed'
import FocusGroup from '../pages/UnAuth/FocusGroup'
import MyBusiness from '../pages/Auth/Business'
import FocusGroupSession from '../pages/Auth/FocusGroupSession'
import FocusGroupAccess from '../pages/UnAuth/FocusGroupAccess'
import MyBookings from '../pages/Auth/Desktop/MyBookings'
import MyBookingsMobile from '../pages/Auth/Mobile/MyBookings'
import PartnerCommunities from '../pages/shared/Desktop/PartnerCommunities'
import PartnerCommunitiesMobile from '../pages/shared/Mobile/PartnerCommunities'
import PartnerResources from '../pages/shared/Desktop/PartnerResources'
import PartnerResourcesMobile from '../pages/shared/Mobile/PartnerResources';
// import Recommendations from '../pages/Auth/Recommendations'



type AuthViewProps = {
  searchFilterOptions: SearchFilterOptionType
}

const AuthView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        <Route path="/focus-group/:sessionId" element={<FocusGroupAccess />}  />
        <Route path="/focus-group/:sessionId/session" element={<FocusGroupSession />}  />
        <Route path="/:resourceType" element={<PartnerResources resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="/all" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  /> */}
        <Route path="/communities" element={<PartnerCommunities />}  />
        <Route path="/business" element={<MyBusiness />}  />
        {/* <Route path="/recommendations" element={<Recommendations resourceType="kitchen" searchFilterOptions={searchFilterOptions}  />}  />   */}
        {/* <Route path="/kitchen" element={<ResourceListing resourceType="kitchen" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/documentation" element={<ResourceListing resourceType="documentation" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/training" element={<ResourceListing resourceType="training" searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/funding" element={<ResourceListing resourceType="funding" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/expert" element={<ResourceListing resourceType="expert" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/farm" element={<ResourceListing resourceType="farm" searchFilterOptions={searchFilterOptions}  />}  /> */}
        <Route path="/:resourceType/:resourceId" element={<ResourceDetails searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/saved" element={<SavedResourceListing searchFilterOptions={searchFilterOptions}/>} />
        <Route path="/bookings" element={<MyBookings searchFilterOptions={searchFilterOptions}/>} />
        <Route path="/wallet" element={<Wallet/>} />
        <Route path="/cart" element={<Cart/>} />
        <Route path="/feed" element={<Feed/>} />
        <Route path="/profile" element={<Profile />}  />
        <Route path="/profile/memberships" element={<Profile />}  />
        <Route path="/profile/subscriptions" element={<Profile />}  />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/finishSignIn" element={<FinishSignIn />} />
        <Route path="/finishSignIn/:login_token" element={<FinishSignIn />} />
        <Route path="*" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="*" element={<ResourceOptions  />}  /> */}
    </Routes>
  )
}


export const MobileAuthView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        <Route path="/focus-group/:sessionId" element={<FocusGroupAccess />}  />
        <Route path="/focus-group/:sessionId/session" element={<FocusGroupSession />}  />
        <Route path="/:resourceType" element={<PartnerResourcesMobile resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/communities" element={<PartnerCommunitiesMobile />}  />
        <Route path="/business" element={<MyBusiness />}  />
        <Route path="/:resourceType/:resourceId" element={<ResourceDetailsMobile searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/wallet" element={<WalletMobile/>} />
        <Route path="/bookings" element={<MyBookingsMobile searchFilterOptions={searchFilterOptions}/>} />
        <Route path="/saved" element={<SavedResourceListingMobile searchFilterOptions={searchFilterOptions}/>} />
        <Route path="/cart" element={<Cart/>} />
        <Route path="/feed" element={<Feed/>} />
        <Route path="/profile" element={<ProfileMobile />}  />
        <Route path="/profile/memberships" element={<ProfileMobile />}  />
        <Route path="/profile/subscriptions" element={<ProfileMobile />}  />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/finishSignIn" element={<FinishSignIn />} />
        <Route path="/finishSignIn/:login_token" element={<FinishSignIn />} />
        <Route path="*" element={<PartnerResourcesMobile resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
    </Routes>
  )
}


export const NoAuthEmailUsernameView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        {/* <Route path="/kitchen" element={<ResourceListing resourceType="kitchen" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/documentation" element={<ResourceListing resourceType="documentation" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/training" element={<ResourceListing resourceType="training" searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/funding" element={<ResourceListing resourceType="funding" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/expert" element={<ResourceListing resourceType="expert" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/farm" element={<ResourceListing resourceType="farm" searchFilterOptions={searchFilterOptions}  />}  /> */}
        <Route path="/:resourceType/:resourceId" element={<ResourceDetails searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/profile" element={<Profile />}  />
        <Route path="/profile/memberships" element={<Profile />}  />
        <Route path="/profile/subscriptions" element={<Profile />}  />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/:resourceType" element={<PartnerResources resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/communities" element={<PartnerCommunities />}  />
        <Route path="/" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="/" element={<ResourceOptions />}   /> */}
        <Route path="*" element={<Profile />}   />
    </Routes>
  )
}


export const MobileNoAuthEmailUsernameView: React.FC<AuthViewProps> = ({searchFilterOptions}) => {
  return (
    <Routes>
        <Route path="/focus-group" element={<FocusGroup />}  />
        <Route path="/focus-group/register" element={<FocusGroup />}  />
        {/* <Route path="/kitchen" element={<ResourceListing resourceType="kitchen" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/documentation" element={<ResourceListing resourceType="documentation" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/training" element={<ResourceListing resourceType="training" searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/funding" element={<ResourceListing resourceType="funding" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/expert" element={<ResourceListing resourceType="expert" searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/farm" element={<ResourceListing resourceType="farm" searchFilterOptions={searchFilterOptions}  />}  /> */}
        <Route path="/:resourceType/:resourceId" element={<ResourceDetails searchFilterOptions={searchFilterOptions}  />}  />
        <Route path="/profile" element={<ProfileMobile />}  />
        <Route path="/profile/memberships" element={<ProfileMobile />}  />
        <Route path="/profile/subscriptions" element={<ProfileMobile />}  />
        <Route path="/privacy" element={<Privacy />}  />
        <Route path="/terms" element={<Terms />}  />
        <Route path="/disclaimer" element={<Disclaimer />}  />
        <Route path="/eula" element={<Eula />}  />
        <Route path="/:resourceType" element={<PartnerResources resourceType={searchFilterOptions.currentFilter.resourceType} searchFilterOptions={searchFilterOptions} />}  />
        <Route path="/communities" element={<PartnerCommunitiesMobile />}  />
        <Route path="/" element={<PartnerResources resourceType="kitchen" searchFilterOptions={searchFilterOptions} />}  />
        {/* <Route path="/" element={<ResourceOptions />}   /> */}
        <Route path="*" element={<ProfileMobile />}   />
    </Routes>
  )
}


export default AuthView;